// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Qf07","tab":"Tabs_tab__2TAOh","tabActive":"Tabs_tabActive__2jaFV"};